var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.customClasses,style:(_vm.customStyles),attrs:{"href":_vm.field.path,"target":_vm.targetContent}},[_vm._v(" "+_vm._s(_vm.field.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }